<div class="cnae-table-view table-responsive">
    <table class="table table-striped table-hover table-bordered">
        <thead>
            <tr>
                <th class="col-codigo">Código</th>
                <th class="col-nome">Nome</th>
                <th class="col-indicadores" *ngIf="isShowIndicadores"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let cnae of cnaes">
                <td class="col-codigo">
                    {{cnae.codigo}}
                </td>
                <td class="col-nome">
                    {{cnae.apelido ? cnae.apelido : cnae.nome}}

                    <ng-template [ngIf]="cnae.apelido">
                        <br/>
                        <small>
                            {{cnae.nome}}
                        </small>
                    </ng-template>
                </td>
                <td class="col-indicadores" *ngIf="isShowIndicadores">
                    <sgt-cnae-indicador-badges
                        [principal]="cnae.principal"
                        [secundaria]="cnae.secundaria">
                    </sgt-cnae-indicador-badges>
                </td>                                
            </tr>
            <tr *ngIf="!cnaes || cnaes.length == 0"> 
                <td colspan="3" class="text-center">
                    <i class='fas fa-info' aria-hidden='true'></i> {{emptyText}}
                </td>
            </tr>
        </tbody>
    </table>
</div>